/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ImageTextIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAB5klEQVR4nN1Vv0scURDeaH4IkibEfyAYC7GwSb0QMCzczo+VPGdOhC2Eg1ikSZdmq8QLKYJN/oBUUVIGkz8gpIqNpkiniIqgFgmGEEQNb31Ljtvbc2+5NBn4YHfnzfe9mXmzz/P+GzPGXEeWF0Cyh6znVQAsu8jatFw5AeuoSox5NHMCTv3vbkj2gOTUoaesLFenDFoW6Kbv+1cBzKhFo9G4hiRbvYh0FUCS5ZyfZLk/AqSrfhwPtfv9OB5Ckg//VABYPvapRLqSL5Gu9K0Htsm2sbXp+l2L/jc5hexnx9Q+9zoLJQQKQLoGLA1kfYmsJ0C6iIg3M57AmBFkfVZRQL5OTc0NZzEhywPP8654ZayA9AxZfzryY0Qz3ikWSOZbpjgsKSAHtWhmwhgziKSvgTUu3Bzpp5a4d2UETiDS+5kvSZKBInJmGUszTU+ZfAfS32FYv91VAEifFBG2G5I8dzGLyPom5Yj0cVeBMJq555WwJEkGgHXbxhDNTmKkNdeH9Ut/190ALI/SmEgDN5jf7LsdSCA5zAQrXzjkgoH1rSvPEbB8uYD+uPgmSx2uTG1emgnJZ7f+FpL8KsyS5DAIghtlSt3RQqovuMneqE3P3mkFsu6kPtSHlQVsOdxOn7b7kOWV873/A+k7dhuW6PmPAAAAAElFTkSuQmCC)
 */
export const ImageTextIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        d="M5 2a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h7.28c.2 0 .39-.13.46-.32l.76-2a.5.5 0 0 0-.47-.68H5.81a.75.75 0 0 1-.59-1.22l1.86-2.32a1.5 1.5 0 0 1 2.34 0l.5.64 2.23-2.97a2 2 0 0 1 3.2 0l.42.56.15-.4A2 2 0 0 1 17.79 12h2.32c.57 0 1.09.24 1.46.64.11.12.43.04.43-.13V5a3 3 0 0 0-3-3H5Zm3.65 3.08c.67-.65 1.78-.01 1.55.9-.12.49.17.98.65 1.12.9.26.9 1.54 0 1.8a.93.93 0 0 0-.65 1.12c.23.91-.88 1.55-1.55.9a.93.93 0 0 0-1.3 0c-.67.65-1.78.01-1.55-.9a.93.93 0 0 0-.65-1.12c-.9-.26-.9-1.54 0-1.8a.93.93 0 0 0 .65-1.12c-.23-.91.88-1.55 1.55-.9.36.35.94.35 1.3 0Z"
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        clipRule="evenodd"
        className={colorClass}
      />
      <path
        d="M21.61 24.04h2.3L20.11 14H17.8l-3.8 10.04h2.3l.65-1.92h4.02l.65 1.92Zm-4-3.84 1.34-3.92 1.34 3.92H17.6Z"
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
